@if (icon == "android") {
  <a
    target="_blank"
    class="dCenter"
    href="https://play.google.com/store/apps/details?id=com.mentoga"
  >
    <fa-icon [icon]="faAndroid" size="2x" class="me-3"></fa-icon>
    <p class="mb-0 text-light">
      Get it on the
      <span> Google Play </span>
    </p>
  </a>
} @else {
  <a
    target="_blank"
    class="dCenter"
    href="https://apps.apple.com/us/app/mentoga/id6444566620"
  >
    <fa-icon [icon]="faApple" size="2x" class="me-3"></fa-icon>
    <p class="mb-0 text-light">
      Available on the
      <span> App Store </span>
    </p>
  </a>
}
